import React from 'react'
import de from "../translation/de"
import en from "../translation/en"

const TranslationContext = React.createContext()

function TranslationProvider(props) {

    const translation = {
        de,
        en
    };

    const deKeys = getKeysOfObject(null, de)
    const enKeys = getKeysOfObject(null, en)

    const missingDeKeysInEnKeys = [];
    const missingEnKeysInDeKeys = [];
    const shouldFail = deKeys.some(deKey => {
        if (enKeys.indexOf(deKey) < 0) {
            missingDeKeysInEnKeys.push(deKey);
            return true;
        }
        return false;
    }) || enKeys.some(enKey => {
        if (deKeys.indexOf(enKey) < 0) {
            missingEnKeysInDeKeys.push(enKey);
            return true;
        }
        return false;
    })
    if (shouldFail) {
        const errorMessage = `Inkonsitente Übersetzungsdatei - Fehlende Keys in de.js: "${missingEnKeysInDeKeys.join(', ')}"  - Fehlende Keys in en.js: "${missingDeKeysInEnKeys.join(', ')}"`;
        console.error(errorMessage);
        throw new Error(errorMessage);
    }

    return (
        <TranslationContext.Provider value={
            translation[props.language]
        } {...props} />
    )
}

function useTranslation() {
    const context = React.useContext(TranslationContext)
    if (context === undefined) {
        throw new Error(`useTranslation must be used within a TranslationProvider`)
    }
    return context
}

function getKeysOfObject(prefix, obj, keys) {
    const k = Object.keys(obj);
    return k.map(_k => {
        const newKey = [prefix, _k].filter(f => f !== null).join('.')
        if (typeof obj[_k] !== "string") {
            return getKeysOfObject(newKey, obj[_k])
        } else {
            return [newKey]
        }
    }).flat()
}

export {TranslationProvider, useTranslation}